var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height align-start",attrs:{"id":"data-tables","fluid":"","tag":"section"}},[_c('ik-data-table',{attrs:{"model":_vm.model,"entity-name":"DiscountArea","icon":"mdi-cash-usd"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }